export default {
    make: data => ({
      header: `Клапан EGR для ${data.make}`,
      header_uk: `Купити клапан EGR для ${data.make}`,
    }),
  };
  


// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_klapan-egr.js